<template>
  <div class="footer" :style="'background-color: '+data.footerBackgroundColour">
    <p class="centered">
      <img v-for="image in data.footerLogo.images" :src="image.url" />
      <br><br>
      {{ data.footerText }}
    </p>
  </div>
</template>

<script>
import { firestore } from '../main'

export default {
  name: 'FooterBlock',
  props: ['data'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/FooterBlock.vue